import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useGlobalSearch from '../../hooks/useGlobalSearch';

import { useModals } from '../../contexts/ModalContext';

interface GlobalSearchProps {
  /**
   * Test id for button
   */
  testId?: string;
}

const GlobalSearch = ({ testId = '' }: GlobalSearchProps) => {
  const { t } = useTranslation();
  const modal = useModals();
  const globalSearch = useGlobalSearch({ testId });

  useEffect(() => {
    const searchKeyHandler = (e: KeyboardEvent) => {
      if (e.key !== '/' || e.ctrlKey || e.metaKey || e.shiftKey) return;
      if (
        /^(?:input|textarea|select|button)$/i.test(
          (e.target as HTMLElement).tagName,
        )
      )
        return;
      if ((e.target as HTMLElement).isContentEditable) return;

      e.preventDefault();

      globalSearch();
    };

    document.addEventListener('keydown', searchKeyHandler);
    return () => document.removeEventListener('keydown', searchKeyHandler);
  }, [globalSearch, modal, t, testId]);

  return null;
};

export default GlobalSearch;
